import { render, staticRenderFns } from "./PersonPhotoManager.vue?vue&type=template&id=0082315c&scoped=true&"
import script from "./PersonPhotoManager.vue?vue&type=script&lang=js&"
export * from "./PersonPhotoManager.vue?vue&type=script&lang=js&"
import style0 from "./PersonPhotoManager.vue?vue&type=style&index=0&id=0082315c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082315c",
  null
  
)

export default component.exports